export default __webpack_public_path__ + "static/media/warning.015cbf16.svg";